module.exports = __webpack_public_path__ + "static/Physical-Therapy-29b20ff8c4ed55fd882a46d6f2da10fc.webp";